module.exports = __webpack_public_path__ + "static/media/insurance.e6c91568.svg";